import React from "react";
import "../../App.css";
import "./Footer.css";
import { useTranslation } from 'react-i18next';
import {ReactComponent as Mail} from "../../icons/contacts/email.svg";
import {ReactComponent as Phone} from "../../icons/contacts/phone.svg";
import { ReactComponent as Telegram } from '../../icons/contacts/tg.svg';
import { ReactComponent as Whatsapp } from '../../icons/contacts/wa.svg';
import i18n from "../../texts/i18n";

export const Footer = () => {
    const { t } = useTranslation();
    const isInternationalVersion = i18n.options.fallbackLng.length === 1;
    const fieldForShowedAddress = isInternationalVersion ? 'addressInfo' : 'addressInfoRu';
    return (
    <div className="footerMain">
      <div className="areyouready">
        <div className={'areyoureadyText'}>{t('footerGoText')}</div>
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="footerButton"
        >
          <div className="footerButtonText">{t('formbutton')}</div>
        </button>
      </div>
      <div className="footerContact">
        <div className="footerContactsLeft">
          <a href="https://t.me/smsretail" target="_blank" rel="noreferrer" className='contactline'><Telegram /><div>smsretail</div></a>
          <a href="https://api.whatsapp.com/send?phone=79500463666" target="_blank" rel="noreferrer" className='contactline'><Whatsapp /><div>smsretail</div></a>
          <a href="tel:+37496225758" className='contactline'><Phone /><div>+374 96 225758</div></a>
          <a href="mailto:info@sms-retail.ru" target="_blank" rel="noreferrer" className='contactline'><Mail /><div>smsretail</div></a>
        </div>
        <div className="footerAddress">
          {t(fieldForShowedAddress)}
        </div>
      </div>
      <div className="footerBottom">
        <div className="">
            &copy; 2014-2025 SMS Retail
        </div>
          <div className="footerBottomTerms">
              <div className="">
                  Terms of Service
              </div>
              <div className="">
                  Privacy Policy
              </div>
          </div>
      </div>
    </div>
  );
};
